/* eslint-disable no-plusplus */
/* eslint-disable global-require */
import GTM from '../datalayer';

const checkStep = (data) => {
    const actionField = {
        step: 1,
        action: 'checkout',
        option: [],
    };

    if (
        (data.selectedShippingMethod
      && $('.payment-form').css('display') === 'block')
    || (data.selectedShippingMethod
      && $('.payment-summary').css('display') === 'block')
    ) {
        actionField.step = 2;
        actionField.option.push({ shippingMethod: data.selectedShippingMethod.ID });
    }

    if (
        data.selectedPaymentMethod
    && $('.payment-summary').css('display') === 'block'
    ) {
        actionField.step = 3;
        actionField.option.push({ paymentMethod: data.selectedPaymentMethod });
    }

    if (!actionField.option.length) {
        delete actionField.option;
    }

    return actionField;
};

const getCurrency = () => $('meta[itemprop="priceCurrency"]')[0].content;

const infoFirstStepCheckout = () => {
    const url = $('.checkoutDatalayer')[0].value;

    $.ajax({
        url,
        type: 'GET',
        dataType: 'json',
        success(data) {
            const actionfield = checkStep(data);
            GTM.trackCheckoutStep(data.allProducts, actionfield, getCurrency());
        },
        error(err) {
            console.log('datalayer error', err, err.responseText);
        },
    });
};

const infoSecondStepCheckout = () => {
    $('button.submit-shipping').on('click', () => {
        const checkoutDatalayerStep = window.dataLayer.filter(
            obj => obj.event === 'checkout',
        );
        const shippingSelected = $('.shipping-method-block input:checked');
        if (checkoutDatalayerStep.length > 0 && shippingSelected.length > 0) {
            GTM.trackCheckoutStep(
                checkoutDatalayerStep[0].ecommerce.checkout.products,
                {
                    step: 2,
                    option: $('.shipping-method-block input:checked')[0].value,
                    action: 'checkout',
                },
                getCurrency(),
            );
        }
    });
};

const infoThirdStepCheckout = () => {
    $('li.method-wrapper').on('click', () => {
        const checkoutDatalayerStep = window.dataLayer.filter(
            obj => obj.event === 'checkout',
        );
        if (checkoutDatalayerStep.length > 0) {
            setTimeout(() => {
                GTM.trackCheckoutStep(
                    checkoutDatalayerStep[0].ecommerce.checkout.products,
                    {
                        step: 3,
                        option: $('.nav-item > a.active')
                            .parent()
                            .data('method-id'),
                        action: 'checkout',
                    },
                    getCurrency(),
                );
            }, 500);
        }
    });
};

const selectShippingMethodOption = () => {
    let selectedOption = {};
    if ($('.form-check-input').length) {
        $('body').on('change', 'input.form-check-input', (e) => {
            selectedOption = {
                elementTarget: $(e.currentTarget)[0].value,
                labelText: $(e.target)
                    .parent()
                    .find('label')[0].innerText,
            };

            GTM.trackEventOption('click', selectedOption);
        });
    }
};

$(document).ready(() => {
    infoFirstStepCheckout();
    infoSecondStepCheckout();
    infoThirdStepCheckout();
    selectShippingMethodOption();
});
